/* eslint-disable */
import React from 'react'
import { Card, Input, Table } from 'antd'
import { Controller, useFormContext } from 'react-hook-form'
import i18n from 'domain/i18n/i18n'
import RequiredLabel from 'components/RequiredLabel'
import robPermissions from 'constants/robPermissions'
import usePermission from 'hooks/usePermission'
import './temperatureTable.less'

const t = key => i18n.t(`rob.survey.soundingDraftAndTemperature.${key}`)

const getNestedError = (errors, path) =>
  path.split('.').reduce((acc, key) => acc?.[key], errors)

const TEMPERATURE_ROWS = [
  { key: 'outsideTemperature', labelKey: 'temperature.outsideTemperature' },
  {
    key: 'engineRoomTemperature',
    labelKey: 'temperature.engineRoomTemperature',
  },
  { key: 'seawaterTemperature', labelKey: 'temperature.seawaterTemperature' },
]

const TemperatureTable = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  const can = usePermission()
  const canEdit = can(robPermissions.EDIT_GENERAL)

  const columns = [
    {
      dataIndex: 'labelKey',
      key: 'label',
      title: '',
      width: 200,
      render: labelKey => t(labelKey),
    },
    {
      key: 'value',
      title: '',
      width: 140,
      render: (_, record) => {
        const fieldName = `general.soundingDraftAndTemperature.temperature.${record.key}`
        const error = getNestedError(errors, fieldName)
        return (
          <Controller
            name={fieldName}
            control={control}
            render={({ field }) => (
              <div className="temperature-table__input-wrap">
                <Input
                  {...field}
                  disabled={!canEdit}
                  inputMode="decimal"
                  onChange={e =>
                    field.onChange(e.target.value.replace(/[^\d.-]/g, ''))
                  }
                  status={error ? 'error' : ''}
                />
                <RequiredLabel required />
                {error && (
                  <div className="temperature-table__error-msg">
                    {error.message}
                  </div>
                )}
              </div>
            )}
          />
        )
      },
    },
  ]

  return (
    <Card
      className="temperature-table__card"
      size="small"
      title={t('temperature.title')}
    >
      <Table
        bordered
        columns={columns}
        dataSource={TEMPERATURE_ROWS}
        pagination={false}
        rowKey="key"
        showHeader={false}
      />
    </Card>
  )
}

export default TemperatureTable
